import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke321aRequest, Sgke321aResponseWorkTntsh, Sgke322aRequest, Sgke322aResponseSearchresultHyojiInfo, Sgke322aResponseSearchresultList, Sgke323aRequest, Sgke323aRequestUpdateCndtList, Sgke903aRequest, Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { UsedSgke321aService } from '../../services/used-sgke321a.service';
import { UsedSgke322aService } from '../../services/used-sgke322a.service';
import { UsedSgke323aService } from '../../services/used-sgke323a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke320d',
  templateUrl: './sgke320d.component.html',
  styleUrl: './sgke320d.component.scss'
})
export class Sgke320dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 作業担当者 */
  workTntshList: Array<Sgke321aResponseWorkTntsh>;
  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** 検索結果リスト */
  searchresultList: Array<Sgke322aResponseSearchresultList> = new Array<Sgke322aResponseSearchresultList>();
  /** 検索結果表示情報 */
  searchresultHyojiInfo: Sgke322aResponseSearchresultHyojiInfo;
  /** SGKE322Aリクエストデータフォーム */
  searchReqForm: UntypedFormGroup = this.fb.group({});

  /** SGKE322A_供給停止作業割当検索API */
  private requestSgke322a: Sgke322aRequest;
  /** SGKE323A_供給停止作業割当登録API */
  private requestSgke323a: Sgke323aRequest;
  /** 画面ID */
  private static GAMEN_ID = 'SGKE320D';
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UsedSgke321aService} initService
   * @param {UsedSgke322aService} searchService
   * @param {UsedSgke323aService} registService
   * @param {UntypedFormBuilder} fb
   * @param {ChangeDetectorRef} cd
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke320dComponent
   */
  constructor(
    private companyAreaInfoService: UsedSgke903aService,
    public initService: UsedSgke321aService,
    public searchService: UsedSgke322aService,
    public registService: UsedSgke323aService,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private responseMsgUtils: ResponseMsgUtils,
  ) {
  }

  array = new Array;

  /**
   * 初期処理
   * @memberof Sgke320dComponent
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * 購読解除
   * @memberof Sgke320dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * SGKE321A_供給停止作業割当初期表示API呼出し
   * @memberof Sgke320dComponent
   */
  init() {
    let requestInfo: Sgke321aRequest = {
      requestCommon: undefined,
    };

    this.initService.doSgke321a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response.gamenHyojiInfo) {
          this.workTntshList = response?.gamenHyojiInfo.listInfo.workTntsh;
          this.cd.detectChanges();
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        this.companyAreaInfo();
      },
      error => {
      });


  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @memberof Sgke320dComponent
   */
  companyAreaInfo() {
    let requestInfo: Sgke903aRequest = {
      requestCommon: undefined,
      reqBusinessArea: {
        gamenId: Sgke320dComponent.GAMEN_ID
      }
    };
    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response.responseBusinessArea) {
          this.cmpnyAreaList = response?.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response?.responseBusinessArea.initialhyojiInfo;
          this.cd.detectChanges();
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });

  }

  /**
   * 検索ボタン押下時処理
   * @param {boolean} [reSearch=false]
   * @memberof Sgke320dComponent
   */
  onClickSearch(reSearch: boolean = false): void {

    // searchResult初期化
    this.searchresultList.length = 0;
    this.cd.detectChanges();

    // 再検索時はメッセージエリアをクリアしない・リクエストを作らない（初回検索時のリクエストを再利用する）/
    if (!reSearch) {
      this.clearErrorMsg();
      // リクエスト情報をもつオブジェクトを定義
      this.requestSgke322a = this.searchReqForm.getRawValue() as Sgke322aRequest;
    }

    // SGKE322A呼び出し
    this.searchService.doSgke322a(this.requestSgke322a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.searchresultList) {
          this.searchresultList = response.searchresultList;
          this.searchresultHyojiInfo = response.searchresultHyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

      },
      error => {
      }
    );
  }


  /**
 * 登録ボタン押下時処理
 * @param {Sgke322aResponseSearchresultList[]} selected
 * @memberof Sgke320dComponent
 */
  onClickRegist(selected: Sgke322aResponseSearchresultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // オブジェクト生成関数
    let updateCndtListFunc = function (row: Sgke322aResponseSearchresultList): Sgke323aRequestUpdateCndtList {
      return {
        suppntSpno: row.suppntSpno,
        supplystopresumptionRrkno: row.supplystopresumptionRrkno,
        stpClscode: row.stpClsfy.codeValue,
        // 停止種別が現地作業("10")の場合のみ作業担当者をリクエストに含める。
        supplystopresumptionWorktntshId: row.stpClsfy.codeValue === '10' ? row?.tntsh?.codeValue : '',
        supplystopresumptionPointinfomngUpdatesequencenumber: row.supplystopresumptionPointinfomngUpdatesequencenumber,
      };
    }

    // 登録リクエスト情報をもつオブジェクトを定義
    this.requestSgke323a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      updateCndtList: selected.map(updateCndtListFunc)
    };

    // SGKE323A呼び出し
    this.registService.doSgke323a(this.requestSgke323a).pipe(takeUntil(this.onDestroy$)).subscribe(

      response => {
        if (response) {
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          // 再検索
          this.onClickSearch(true);
        }
      },
      error => {
      }
    );
  }

  /**
   * クリアボタン押下時処理
   * @memberof Sgke320dComponent
   */
  onClickClear(): void {
    // エラーメッセージクリア
    this.clearErrorMsg();
    this.searchresultList.length = 0;
    this.searchresultHyojiInfo = null;
  }


  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke320dComponent
   */
  public clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

}
